// @ts-nocheck
import apiClient from "../utils/apiClient";

const getStoredUserId = () => {
  try {
    const storedUser = JSON.parse(localStorage.getItem("user") || "null");

    return (
      storedUser?.id ||
      storedUser?.userId ||
      storedUser?.userID ||
      storedUser?.userid
    );
  } catch {
    return null;
  }
};

const requireUserId = (userId) => {
  const resolvedUserId = userId || getStoredUserId();

  if (!resolvedUserId) {
    throw new Error("User ID is missing");
  }

  return resolvedUserId;
};

const addressApi = {
  getMyAddresses: async (userId) => {
    const resolvedUserId = requireUserId(userId);
    const response = await apiClient.get(`/api/addresses/me/${resolvedUserId}`);
    return Array.isArray(response.data) ? response.data : [];
  },

  createAddress: async (userId, data) => {
    const resolvedUserId = requireUserId(userId);
    const response = await apiClient.post(`/api/addresses/${resolvedUserId}`, data);
    return response.data;
  },

  updateAddress: async (id, data) => {
    const response = await apiClient.put(`/api/addresses/${id}`, data);
    return response.data;
  },

  deleteAddress: async (id) => {
    await apiClient.delete(`/api/addresses/${id}`);
  },
};

export default addressApi;
